import C from 'utils/values/constant.util';

// TODO: temporary, to be removed, along with all these selectors, the entire file
const STATE = C({
  isFetching: false,
  completed: true,
  salonId: 0,
  features: {
    // In the reducer, these were preset to a certain value:
    // stockManagement: false,
    // patchTestVisibility: false,
    // hideMiniModal: true,
    //
    // In the console, these were logged as true:
    ChargeCardOnFile: true,
    bookingInlineDatePicker: true,
    clientCommunications: true,
    enablePincodes: true,
    fbConnect: true,
    patchTestVisibility: true,
    repeatBookings: true,
    showRequestDeposit: true,
    stockManagement: true,
    //
    // In the Jira issue, these were mentioned:
    hideStaffManagement: false,
    renderOnlyWhenVisible: false, // from Jira: only 1 salon uses this flag so happy to delete
    hideMiniModal: false, // from Jira: only 1 salon uses this flag so happy to delete
    //
  },
  response: {},
});

export const selectOldFlagsCompleted = () => STATE.completed;
export const selectOldFlagsFeatures = () => STATE.features;

export const selectOldFlagsChargeCardOnFile = () => STATE.features.ChargeCardOnFile;
export const selectOldFlagsHideMiniModal = () => STATE.features.hideMiniModal;
export const selectOldFlagsHideStaffManagement = () => STATE.features.hideStaffManagement;
export const selectOldFlagsPincodes = () => STATE.features.enablePincodes;
